<template>
    <el-container style="overflow: auto;height: 100%" class="sale">
        <el-header style="height: 30px">
            <van-nav-bar title="新增仪器销售" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main>
            <el-form ref="form" :model="inteboSale" size="mini" label-width="80px" :rules="rules">
                <el-form-item label="单号" prop="sysbillid">
                    <span>{{inteboSale.sysbillid}}</span>
                </el-form-item>
                <el-form-item label="门店名称" prop="storeid">
                    <span v-if="show">{{inteboSale.parentname}}/{{inteboSale.storename}}</span>
                    <el-cascader :options="storeData" filterable clearable v-model="parentstoreid" size="mini" style="width: 100%" @change="storeChange" v-else></el-cascader>
                </el-form-item>
                <el-form-item label="仪器价格" prop="totalamount">
                    <span v-if="show">{{inteboSale.totalamount}}</span>
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="inteboSale.totalamount" v-else>
                    </el-input-number>
                </el-form-item>
                <el-form-item label="合作模式" prop="hzmode">
                    <div v-if="show">
                        <el-tag v-if="inteboSale.hzmode==1">全款</el-tag>
                        <el-tag v-if="inteboSale.hzmode==2">金融</el-tag>
                        <el-tag v-if="inteboSale.hzmode==3">9800</el-tag>
                    </div>
                    <el-radio-group v-model="inteboSale.hzmode" v-else>
                        <el-radio :label="1">全款</el-radio>
                        <el-radio :label="2">金融</el-radio>
                        <el-radio :label="3">9800</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="inteboSale.hzmode==2?'定金':'首付'" prop="sfpayment" v-if="inteboSale.hzmode==2 || inteboSale.hzmode==3">
                    <span v-if="show">{{inteboSale.sfpayment}}</span>
                    <el-input-number v-else style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="inteboSale.sfpayment">
                    </el-input-number>
                </el-form-item>

                <el-form-item label="签约公司" prop="qystore">
                    <span v-if="show">{{inteboSale.qystorename}}</span>
                    <el-select v-model="inteboSale.qystore" placeholder="请选择" style="width: 100%" filterable default-first-option clearable v-else>
                        <el-option v-for="(item,key) in qyStoreData" :value="item.constantid" :label="item.constantname" :key="key"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="支付状态" prop="paystatus">
                    <div v-if="show">
                        <el-tag v-if="inteboSale.paystatus==1">支付完成</el-tag>
                        <el-tag v-if="inteboSale.paystatus==0" type="danger">未支付</el-tag>
                    </div>
                    <el-switch v-model="inteboSale.paystatus" active-text="支付" inactive-text="未支付" :active-value="1" :inactive-value="0" v-else>
                    </el-switch>
                </el-form-item>
                <el-form-item label="支付日期" prop="paydate">
                    <span v-if="show">{{inteboSale.paydate}}</span>
                    <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100%" v-else
                                    v-model="inteboSale.paydate"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="金融放款" prop="back" v-if="inteboSale.hzmode==2">
                    <div v-if="show">
                        <el-tag v-if="inteboSale.back==1">已放</el-tag>
                        <el-tag v-if="inteboSale.back==0" type="danger">未放</el-tag>
                    </div>
                    <el-switch v-model="inteboSale.back" active-text="放贷" inactive-text="未放贷" :active-value="1" :inactive-value="0" v-else>
                    </el-switch>
                </el-form-item>
                <el-form-item label="放款日期" prop="backdate" v-if="inteboSale.hzmode==2">
                    <span v-if="show">{{inteboSale.backdate}}</span>
                    <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100%" v-else
                                    v-model="inteboSale.backdate"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="回款比率" prop="backlv" v-if="inteboSale.hzmode==3">
                    <span v-if="show">{{inteboSale.backlv}}</span>
                    <el-input-number style="text-align: left;width: 100%" :precision="1" :controls="false" :min="0" size="mini" v-model="inteboSale.backlv" v-else>
                    </el-input-number>
                </el-form-item>
                <el-form-item label="合同" prop="ht">
                    <div v-if="show">
                        <el-tag v-if="inteboSale.ht==1">已放</el-tag>
                        <el-tag v-if="inteboSale.ht==0" type="danger">未放</el-tag>
                    </div>
                    <el-switch v-model="inteboSale.ht" active-text="确定" inactive-text="未确定" :active-value="1" :inactive-value="0" v-else>
                    </el-switch>
                </el-form-item>
                <!--<el-form-item label="奖励方案" prop="bonus">
                    <div v-if="show">
                        <el-tag v-if="inteboSale.bonus==1">确定</el-tag>
                        <el-tag v-if="inteboSale.bonus==0" type="danger">未确实</el-tag>
                    </div>
                    <el-switch v-model="inteboSale.bonus" active-text="确定" inactive-text="未确定" :active-value="1" :inactive-value="0" v-else>
                    </el-switch>
                </el-form-item>
                <el-form-item label="奖励金额" prop="bonusamount" v-if="inteboSale.bonus==1">
                    <span v-if="show">{{inteboSale.bonusamount}}</span>
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="inteboSale.bonusamount" v-else>
                    </el-input-number>
                </el-form-item>
                <el-form-item label="奖励支付日期" prop="backdate" v-if="inteboSale.bonus==1">
                    <span v-if="show">{{inteboSale.bonuspaydate}}</span>
                    <el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 100%" v-else
                                    v-model="inteboSale.bonuspaydate"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>-->
                <el-form-item label="仪器SN" prop="sn">
                    <span v-if="show">{{inteboSale.sn}}</span>
                    <el-input v-model="inteboSale.sn" @change="checkSn" v-else></el-input>
                </el-form-item>
                <el-form-item label="仪器型号" prop="yqmodel">
                    <span v-if="show">{{inteboSale.yqmodel}}</span>
                    <el-select v-model="inteboSale.yqmodel" placeholder="请选择" style="width: 100%" clearable v-else>
                        <el-option value="C100" label="C100" key="C100"></el-option>
                        <el-option value="IA200" label="IA200" key="IA200"></el-option>
                        <el-option value="IA100" label="IA100" key="IA100"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="介绍类型" prop="jstype" v-if="show">
                    <span >
                        <el-tag v-if="inteboSale.jstype==1">独立介绍人</el-tag>
                        <el-tag v-if="inteboSale.jstype==2">总监</el-tag>
                        <el-tag v-if="inteboSale.jstype==3">店介绍店</el-tag>
                        <el-tag v-if="inteboSale.jstype==4">小红书</el-tag>
                    </span>
                </el-form-item>
                <el-form-item label="介绍人" prop="jstor" v-if="show">
                    <div >
                        <div v-if="inteboSale.jstorname">{{inteboSale.jstorname}}</div>
                        <div v-else>{{inteboSale.jstor}}</div>
                    </div>
                </el-form-item>
                <el-form-item label="介绍费" prop="jsamount" v-if="show">
                    <span >{{inteboSale.jsamount}}</span>
                </el-form-item>
                <el-form-item label="介绍总监" prop="jszj" v-if="show">
                    <div >
                        <div v-if="inteboSale.jszjname">{{inteboSale.jszjname}}</div>
                        <div v-else>{{inteboSale.jszj}}</div>
                    </div>
                </el-form-item>
                <el-form-item label="介绍费" prop="jszjamount" v-if="show">
                    <span >{{inteboSale.jszjamount}}</span>
                </el-form-item>
                <!--<el-form-item label="介绍类型" prop="jstype">
                    <span v-if="show">
                        <el-tag v-if="inteboSale.jstype==1">独立介绍人</el-tag>
                        <el-tag v-if="inteboSale.jstype==2">总监</el-tag>
                        <el-tag v-if="inteboSale.jstype==3">店介绍店</el-tag>
                        <el-tag v-if="inteboSale.jstype==4">小红书</el-tag>
                    </span>
                    <el-radio-group v-model="inteboSale.jstype" v-else>
                        <el-radio :label="1">独立介绍人</el-radio>
                        <el-radio :label="2">店介绍店</el-radio>
                        <el-radio :label="3">小红书</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="介绍人" prop="jstor">
                    <div v-if="show">
                        <div v-if="inteboSale.jstorname">{{inteboSale.jstorname}}</div>
                        <div v-else>{{inteboSale.jstor}}</div>
                    </div>
                    <div v-else>
                        <el-input v-model="inteboSale.jstor" v-if="inteboSale.jstype!=2"></el-input>
                        <el-cascader :options="storeData" clearable v-model="storeParentNameData" size="mini"  style="width: 100%" @change="jsmdChange" v-else></el-cascader>
                    </div>
                </el-form-item>
                <el-form-item label="介绍费" prop="jsamount">
                    <span v-if="show">{{inteboSale.jsamount}}</span>
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="inteboSale.jsamount" v-else>
                    </el-input-number>
                </el-form-item>
                <el-form-item label="介绍总监" prop="jszj">
                    <div v-if="show">
                        <div v-if="inteboSale.jszjname">{{inteboSale.jszjname}}</div>
                        <div v-else>{{inteboSale.jszj}}</div>
                    </div>
                    <div v-else>
                        <el-select v-model="inteboSale.jszj" placeholder="请选择" style="width: 100%" filterable default-first-option>
                            <el-option v-for="(item,key) in zjData" :value="item.staffid" :label="item.staffname" :key="key"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="介绍费" prop="jszjamount">
                    <span v-if="show">{{inteboSale.jszjamount}}</span>
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="inteboSale.jszjamount" v-else>
                    </el-input-number>
                </el-form-item>-->
                <el-table height="150px" class="productTable" border :data="inteboSendData" size="mini" style="text-align: center" highlight-current-row :bean="intebosend">
                    <el-table-column label="赠送内容"  align="center"prop="sendcontent">
                        <template slot-scope="scope">
                            <span v-if="show">{{scope.row.sendcontent}}</span>
                            <el-input :ref="scope.column.property+'_'+scope.$index" v-else @keyup.enter.native="tableEnter(scope)" size="mini" v-model="scope.row.sendcontent"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否完成"  align="center" prop="finished" v-if="show">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.finished==1">完成</el-tag>
                            <el-tag v-if="scope.row.finished==0" type="danger">未完成</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </el-main>
        <el-footer v-if="show==false">
            <el-button type="primary" :loading="loading" @click="saveInteboSale" style="width: 100%">保存</el-button>
        </el-footer>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            parentstoreid:[],
            show:false,
            qyStoreData:[],
            zjData:[],
            loading:false,
            columnIndexs:[],
            inteboSendData:[],
            intebosend:{
                sn:"",
                yqmodel:"",
                sendcontent:"",
                finished:0,
            },
            inteboSale: {
                parentid:"",
                storeid: "",
                sysbillid: "",
                totalamount: 0,
                hzmode: 0,
                ht: 0,
                yqmodel: "",
                sn: "",
                sfpayment: 0,
                bonus: 0,
                backlv: 0,
                qystore: "",
                jstype: 0,
                jstor: "",
                jsamount: 0,
                paystatus: 0,
                paydate: "",
                createdate: "",
                createtor: "",
                createtorname: "",
                back: 0,
                backdate: "",
                jszj:"",
                jszjamount:0,
                bonusamount:0,
                bonuspaydate:"",
            },
            storeParentNameData:[],
            storeData:[],
            rules: {
                storeid: [
                    {required: true, message: "请选择门店", trigger: 'blur'},
                ],
                totalamount: [
                    {required: true, message: "请输入总金额", trigger: 'blur'},
                ],
                hzmode:[
                    {required: true, message: "请选择合作模式", trigger: 'blur'},
                ]
            },
        }
    },
    created() {
        let sysbillid=this.$route.query.sysbillid;
        if(sysbillid){
            let type=this.$route.query.type;
            if(type=='show'){
                this.show=true;
            }
            this.getInteboSaleById(sysbillid);
            this.getInteboSendBill(sysbillid);
        }
        else{
            this.inteboSendData.push(this.$copy(this.intebosend));
            this.getSysBillId();
        }
        this.getInteboStoreAll();
        this.getInteboStaffByParam();
        this.getQyStore();
        //this.getInteboStoreAndParentName();
    },
    methods:{
        jsmdChange(val) {
            this.inteboSale.jstor = "";
            if (val[1]) {
                this.inteboSale.jstor = val[1];
            }
            else if (val[0]) {
                this.inteboSale.jstor = val[0];
            }
        },
        /*getInteboStoreAndParentName(){
            this.$post("inteboStore/getInteboStoreAndParentName").then(res=>{
                if(res.sucess){
                    this.storeParentNameData=res.object;
                }
            });
        },*/
        storeChange(val){
            this.inteboSale.parentid="";
            this.inteboSale.storeid="";
            if(val[0]){
                this.inteboSale.parentid=val[0];
            }
            if(val[1]){
                this.inteboSale.storeid=val[1];
            }
        },
        getInteboSendBill(sysbillid){
            this.$post("intebosale/getInteboSendBill",{sysbillid: sysbillid}).then(res=>{
                if(res.sucess){
                    this.inteboSendData=res.object;
                    if(this.inteboSendData==null || this.inteboSendData.length<1){
                        this.inteboSendData.push(this.$copy(this.intebosend));
                    }
                }
            });
        },
        getInteboSaleById(sysbillid){
            this.$post("intebosale/getInteboSaleById",{sysbillid: sysbillid}).then(res=>{
                if(res.sucess){
                    this.inteboSale=res.object;
                    let array=[];
                    let jsArray=[];
                    if(this.inteboSale.jstype==2){
                        if(this.inteboSale.jszj){
                            jsArray.push(this.inteboSale.jstorparentid);
                            jsArray.push(this.inteboSale.jstor);
                        }
                    }
                    if(this.inteboSale.storeid){
                        array.push(this.inteboSale.parentid);
                        array.push(this.inteboSale.storeid);
                    }
                    else{
                        array.push(this.inteboSale.parentid);
                    }
                    this.$nextTick(function (){
                        this.parentstoreid=array;
                        this.storeParentNameData=jsArray;
                    });
                }
            });
        },
        getQyStore(){
            this.$post("basis/getConstantInfo",{storeid:"d4415a55a08a4411b7db78d4a50575c3",constanttype:"QYGS",lv:2,status:0,guid:""}).then(res=>{
                if(res.sucess){
                    this.qyStoreData=res.object;
                }
            });
        },
        getInteboStaffByParam(){
            this.$post("inteboStaff/getInteboStaffByType",{type:1}).then(res=>{
                if(res.sucess){
                    this.zjData=res.object;
                }
            });
        },
        getSysBillId(){
            this.$post("product/getSysBillId").then(res=>{
                if(res.sucess){
                    this.inteboSale.sysbillid=res.object;
                }
                else{
                    this.$message({message: res.message, type: 'error'});
                }
            });
        },
        saveInteboSale() {
            this.loading=true;
            if (!this.inteboSale.parentid) {
                this.loading=false;
                this.$message({message: "请选择品牌信息", type: 'error'});
                return;
            }
            if (this.inteboSale.totalamount < 1) {
                this.loading=false;
                this.$message({message: "请输入仪器价格", type: 'error'});
                return;
            }
            if (this.inteboSale.hzmode < 1) {
                this.loading=false;
                this.$message({message: "请选择合作模式", type: 'error'});
                return;
            }
            /*if(this.inteboSale.hzmode==2){
                if(this.inteboSale.sfpayment<1){
                    this.loading=false;
                    this.$message({message: "请输入定金金额", type: 'error'});
                    return;
                }
            }*/
            /*if(this.inteboSale.hzmode==3) {
                if (this.inteboSale.sfpayment < 1) {
                    this.loading=false;
                    this.$message({message: "请输入首付金额", type: 'error'});
                    return;
                }
            }*/
            if(this.inteboSale.paystatus==1){
                if(!this.inteboSale.paydate){
                    this.loading=false;
                    this.$message({message: "请选择支付日期", type: 'error'});
                    return;
                }
            }

            if(this.inteboSale.back==1) {
                if (!this.inteboSale.backdate) {
                    this.loading = false;
                    this.$message({message: "请选择回款日期", type: 'error'});
                    return;
                }
            }

            if(this.inteboSale.sn || this.inteboSale.yqmodel) {
                if (!this.inteboSale.yqmodel) {
                    this.loading = false;
                    this.$message({message: "请选择仪器型号", type: 'error'});
                    return;
                }
                if (!this.inteboSale.sn) {
                    this.loading = false;
                    this.$message({message: "请输入仪器型号", type: 'error'});
                    return;
                }
            }

            if(this.inteboSale.jstype==2){
                if(!this.inteboSale.jstor){
                    this.loading = false;
                    this.$message({message: "请选择介绍门店", type: 'error'});
                    return;
                }
                if(this.inteboSale.jsamount<1){
                    this.loading = false;
                    this.$message({message: "请输入介绍费", type: 'error'});
                    return;
                }
            }

            if(this.inteboSale.bonus==1){
                if (this.inteboSale.bonusamount<1) {
                    this.loading = false;
                    this.$message({message: "请输入方案金额", type: 'error'});
                    return;
                }

                if (!this.inteboSale.bonuspaydate) {
                    this.loading = false;
                    this.$message({message: "请输入方案支付日期", type: 'error'});
                    return;
                }

            }

            let inteboSaleVo = new Object();
            this.inteboSale.createtor=localStorage.getItem("staffid");
            this.inteboSale.createtorname=localStorage.getItem("staffname");
            inteboSaleVo.inteboSale = this.inteboSale;
            let inteboSends = [];
            for (let val of this.inteboSendData) {
                if (val.sendcontent) {
                    inteboSends.push(val);
                }
            }
            inteboSaleVo.inteboSends = inteboSends;
            this.$postw("intebosale/saveInteboSale",inteboSaleVo).then(res => {
                this.loading=false;
                if (res.sucess) {
                    this.$router.push({path:'/intebosale'});
                    this.$message({message: "保存成功", type: 'success'});
                }
            });
        },
        checkSn(){
            if(!this.inteboSale.sn){
                return;
            }
            this.$post("intebosale/checkSn",{sn:this.inteboSale.sn}).then(res=>{
                if(res.sucess){

                }
                else{
                    this.inteboSale.sn="";
                    this.$message({message: res.message, type: 'error'});
                }
            });
        },
        getInteboStoreAll(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
                else{
                    this.$message({message: res.message, type: 'error'});
                }
            });
        },
        tableEnter(scope) {
            var column = scope.store.states.columns;
            var length = column.length;
            if (this.columnIndexs.length < 1) {
                if (column != null && column.length > 0) {
                    for (var i = 0; i < column.length; i++) {
                        this.columnIndexs[column[i].property] = i;
                    }
                }
            }
            var conname = scope.column.property + "_" + scope.$index;
            var curCon = this.$refs[conname];
            console.log(curCon.$options._componentTag);
            if(curCon.$options._componentTag=="el-select"){
                curCon.blur();
            }
            if( curCon.$options._componentTag=="el-date-picker") {
                curCon.hidePicker();
            }
            console.log(curCon);
            var index = this.columnIndexs[scope.column.property];
            while (index <= length - 1) {
                if (index == column.length - 1) {
                    if ((scope.store.table.$options.propsData.data.length - 1) == scope.$index) {
                        scope.store.table.$options.propsData.data.push(this.$copy(scope.store.table.$attrs.bean));
                        //this.rooms.push(this.$copy(this.room));
                        this.$nextTick(function () {
                            conname = column[0].property+"_" + (scope.$index + 1);
                            var con = this.$refs[conname];
                            con.focus();
                            con.$children[0].select();
                        });
                    }
                    else {
                        conname = column[0].property+"_" + (scope.$index + 1);
                        var con = this.$refs[conname];
                        con.focus();
                        con.select();
                    }
                }
                else {
                    var property = scope.store.states.columns[index + 1].property;
                    conname = property + "_" + scope.$index;
                    var con = this.$refs[conname];
                    if (con != undefined) {
                        if (con.disabled == false) {
                            con.focus();
                            con.$children[0].select();
                            break;
                        }
                    }
                }
                index++
            }
        }
    }
}
</script>

<style lang="scss" rel="stylesheet/scss">
    .sale .el-input-number .el-input__inner {
        text-align: left;
    }


    .productTable {
        .el-button{
            padding: 0px;
        }
        &.el-table--enable-row-hover {
            /*.el-table__body {
                tr{
                    &:hover{
                        &>td{
                            background-color:transparent;
                        }
                    }
                }
            }*/
        }
        .el-table__row {
            td {
                padding: 0;
                .cell {
                    padding: 0 !important;
                    .el-input {
                        input {
                            font-size: .7rem;
                            text-align: initial;
                            background-color: transparent;
                            border: 1px solid transparent;
                            height: 1rem;
                            padding: 1rem .5rem;
                            border-radius: 0;
                            &:focus {
                                border-color: #409eff;
                                background-color: #fff;
                            }
                            &[disabled] {
                                background-color: #fbfbfb;
                            }
                        }
                    }
                    .el-select {
                        .el-input {
                            &.is-disabled {
                                .el-input__inner {
                                    &:hover {
                                        border-color: transparent;
                                    }
                                }
                            }
                        }
                    }
                    .el-date-editor {
                        &.el-input {
                            width: auto;
                        }
                        .el-input__prefix {
                            right: 0;
                            left: inherit;
                            .el-input__icon {
                                line-height: 1;
                                opacity: .2;
                            }
                        }
                        .el-input__suffix {
                            .el-icon-circle-close {
                                display: none;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/addintebosale.vue